import store from '../reducers/store';

export default function translate(sentence) {
  const language = store.getState().formState.Page_language;
  if (language === 'English') {
    return sentence;
  }
  const languageObj = store.getState().languageReducer;

  return languageObj[sentence];
}
